//import Input from "../../components/Input/InputSignUp";
import { useState } from "react";
import { Link } from "react-router-dom"

import { MdEmail, MdLockOpen} from "react-icons/md";
import BG from '../../../assets/login.png'
import { Container } from "./style";

import Button from "../../../components/Button";
import {alert} from "../../../components/Alert";
import { useUserContext } from "../../../components/contexts/useUserContext";
import Input from '../../../components/Tmp'


const LoginPage = () => {

    const {login} = useUserContext();
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [selected, setSelected] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if(email === ''){
            alert('Insira o email', 'warn')
        }else if(password === ''){
            alert('Insira a senha', 'warn')
        }

        await login({email, password})
        
    }
    return (
        <Container>
            <div className='image-container'>
                <img src={BG} alt="imagem-login"/>
            </div>
            <div className='forms-container'>
                <form onSubmit={handleSubmit}>
                    <h3>Já sou cliente Vai de Férias</h3>
                        <Input
                            placeholder ='Email' 
                            onChange ={(value) => setEmail(value.target.value)}
                            type='email'
                            Icon = {MdEmail}
                            required
                        />
                        <Input
                            type = 'password'
                            Icon={MdLockOpen}
                            placeholder='Senha'
                            onChange ={(value) => setPassword(value.target.value)}
                            onClick={() => setSelected(!selected)}
                            required
                        />
                    <span>Esqueceu sua senha?</span>
                    <Button format="submit">Entrar Na Minha Conta</Button>
                    <Link to='/sign_up'>
                        <span>Criar uma Conta</span>
                    </Link>
                    <hr/>
                    <Link to='/login/revendedor'>
                        <Button format="submit">Sou revendedor</Button>
                    </Link>
                    <Link to='/login/admin'>
                        <span>Área de administração</span>
                    </Link>
                </form>
            </div>
        </Container>
    );
}


export default LoginPage;